import { render, staticRenderFns } from "./TariffPayComplete.vue?vue&type=template&id=0537d476&"
import script from "./TariffPayComplete.vue?vue&type=script&lang=js&"
export * from "./TariffPayComplete.vue?vue&type=script&lang=js&"
import style0 from "./TariffPayComplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports